import AvaliacaoService from '../../services/AvaliacaoService'

const state = () => ({
    loadingAvaliacao: false,
    avaliacao: null,
    avaliacoes: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_avaliacao: false,
    // Cache para otimização
    questoesCache: {},
    resultadosCache: {},
    detalhesCache: {}
})
  
const mutations = {
    SET_AVALIACAO: (state, payload) => {
        state.avaliacao = payload
    },
    SET_AVALIACOES: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.avaliacoes = payload.itens
        }else{
            state.avaliacoes = [...state.avaliacoes, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_AVALIACOES_USERS: (state, payload) => {
        state.avaliacoes = payload.itens
    },
    SET_LOADING_AVALIACOES: (state, payload) => {
        state.loadingAvaliacao = payload
    },
    SET_SHOW_MODAL_AVALIACAO: (state, payload) => {
        state.show_modal_new_avaliacao = payload
    },
    // Cache mutations
    SET_QUESTOES_CACHE: (state, { avaliacaoId, questoes }) => {
        state.questoesCache[avaliacaoId] = questoes
    },
    SET_RESULTADOS_CACHE: (state, { avaliacaoId, resultados }) => {
        state.resultadosCache[avaliacaoId] = resultados
    },
    SET_DETALHES_CACHE: (state, { key, detalhes }) => {
        state.detalhesCache[key] = detalhes
    },
    CLEAR_CACHE: (state) => {
        state.questoesCache = {}
        state.resultadosCache = {}
        state.detalhesCache = {}
    }
}

const actions = {
    async fetchAvaliacao({commit}, id){
        if (!id) {
            commit('SET_AVALIACAO', null);
            return;
        }
        
        try{
            commit('SET_LOADING_AVALIACOES', true)
            const response = await AvaliacaoService.getOne(id);
            
            if (response && response.data) {
                commit('SET_AVALIACAO', response.data);
            } else {
                commit('SET_AVALIACAO', null);
                commit('SET_ALERT', {
                    heading: 'error',
                    message: 'Avaliação não encontrada'
                });
            }
        } catch (error) {
            console.error('Erro ao buscar avaliação:', error);
            commit('SET_AVALIACAO', null);
            
            if (error.response?.status === 401) {
                commit('LOG_USER_OUT');
            } else {
                commit('SET_ALERT', {
                    heading: 'error',
                    message: error.response?.data?.message || 'Erro ao carregar avaliação'
                });
            }
        } finally {
            commit('SET_LOADING_AVALIACOES', false);
        }
    },
    async fetchAvaliacoes({commit}, { keyword = '', pageNumber = 1, sortBy = 'mais recentes' }){
        try{
            commit('SET_LOADING_AVALIACOES', true)
            const response = await AvaliacaoService.get(keyword, pageNumber, sortBy);
            commit('SET_AVALIACOES', response.data)
            commit('SET_LOADING_AVALIACOES', false)
        } catch (error) {
            commit('SET_LOADING_AVALIACOES', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createAvaliacao({commit}, data){
        try{
            commit('SET_LOADING_AVALIACOES', true)
            const response = await AvaliacaoService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_SHOW_MODAL_AVALIACAO', false)
            commit('SET_LOADING_AVALIACOES', false)
        } catch (error) {
            commit('SET_LOADING_AVALIACOES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeAvaliacao({commit}, data){
        try{
            commit('SET_LOADING_AVALIACOES', true)
            const response = await AvaliacaoService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_AVALIACOES', false)
        } catch (error) {
            commit('SET_LOADING_AVALIACOES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async getQuestoesAvaliacao({commit, state}, avaliacaoId){
        // Verificar cache primeiro
        if (state.questoesCache[avaliacaoId]) {
            return state.questoesCache[avaliacaoId];
        }
        
        try{
            const response = await AvaliacaoService.getQuestoes(avaliacaoId);
            const questoes = response.data;
            
            // Armazenar no cache
            commit('SET_QUESTOES_CACHE', { avaliacaoId, questoes });
            
            return questoes;
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao carregar questões'
            });
            return [];
        }
    },
    async saveQuestoesAvaliacao({commit}, {avaliacaoId, questoes}){
        try{
            const response = await AvaliacaoService.saveQuestoes(avaliacaoId, questoes);
            
            // Limpar cache das questões após salvar
            commit('SET_QUESTOES_CACHE', { avaliacaoId, questoes: null });
            
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            return response.data;
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao salvar questões'
            });
            throw error;
        }
    },
    async getResultadosAvaliacao({commit, state}, avaliacaoId){
        // Verificar cache primeiro
        if (state.resultadosCache[avaliacaoId]) {
            return state.resultadosCache[avaliacaoId];
        }
        
        try{
            const response = await AvaliacaoService.getResultados(avaliacaoId);
            const resultados = response.data;
            
            // Armazenar no cache
            commit('SET_RESULTADOS_CACHE', { avaliacaoId, resultados });
            
            return resultados;
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao carregar resultados'
            });
            return [];
        }
    },
    async getDetalhesResposta({commit, state}, {avaliacaoId, tentativa, userId}){
        const cacheKey = `${avaliacaoId}_${tentativa}_${userId}`;
        
        // Verificar cache primeiro
        if (state.detalhesCache[cacheKey]) {
            return state.detalhesCache[cacheKey];
        }
        
        try{
            const response = await AvaliacaoService.getDetalhesResposta(avaliacaoId, tentativa, userId);
            const detalhes = response.data;
            
            // Armazenar no cache
            commit('SET_DETALHES_CACHE', { key: cacheKey, detalhes });
            
            return detalhes;
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao carregar detalhes da resposta'
            });
            throw error;
        }
    },
}

const getters = {
    getAvaliacao: state => state.avaliacao,
    getAvaliacoes: state => state.avaliacoes,
    getLoadingAvaliacao: state => state.loadingAvaliacao,
    getShowModalNewAvaliacao: state => state.show_modal_new_avaliacao
}

export default {
    state,
    getters,
    mutations,
    actions
};